import { jsx as _jsx } from "react/jsx-runtime";
import { Skeleton } from 'antd';
const Loading = () => (_jsx(Skeleton, { style: { margin: '24px 40px', height: '60vh' }, active: true }));
export default Loading;
